// get mbr-site-dashboard
import React, { useEffect } from 'react'
import useAxios from 'axios-hooks'

export const useMbrSiteDashboard = () => {
  const [{ data, loading, error }, refetch] = useAxios(
    { url: 'mbr-site-dashboard' },
    { manual: false }
  )

  return {
    data,
    loading,
    error,
    refetch,
  }
}
